import { render } from "./SamplingPointForm.component.vue?vue&type=template&id=595d1dbe&scoped=true&ts=true"
import script from "./SamplingPointForm.component.vue?vue&type=script&lang=ts"
export * from "./SamplingPointForm.component.vue?vue&type=script&lang=ts"

import "./SamplingPointForm.component.vue?vue&type=style&index=0&id=595d1dbe&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595d1dbe"]])

export default __exports__